

import React, { useEffect, useState } from "react";
import logo from "assets/img/Logo_Alapar.jpg";
import { Card, Row } from "react-bootstrap";
import styles from "./Links.module.scss";

function Links(props) {
    const [loading, setLoading] = useState(true);
    const currentPath = window.location.pathname; // Get the current path

    const getHref = () => {
        // Logic to determine the new href based on the current path
        /* if (currentPath === "/fisico/zona5") {
            return 'Hola, me gustaría su asesoría con mis dudas financieras';
        } else if (currentPath === "/digital") {
            return "Hola Coopap, me gustaría más información de sus préstamos hipotecarios";
        } else if (currentPath === "/fisico/mixco") {
            return "Hola Mixco";
        } else { */
            return 'Hola%2C%20vengo%20de%20Instagram%20%F0%9F%93%B2%20%C2%BFC%C3%B3mo%20funciona%20su%20pr%C3%A9stamo%20hipotecario%20y%20qu%C3%A9%20necesito%20para%20aplicar%3F%20%F0%9F%8F%A1';
        /* } */
    };

    useEffect(() => {
        setLoading(false);
    }, [])

    useEffect(() => {
        // Create meta elements
        const cacheControlMeta = document.createElement('meta');
        cacheControlMeta.httpEquiv = 'cache-control';
        cacheControlMeta.content = 'no-cache';

        const expiresMeta = document.createElement('meta');
        expiresMeta.httpEquiv = 'expires';
        expiresMeta.content = '0';

        const pragmaMeta = document.createElement('meta');
        pragmaMeta.httpEquiv = 'pragma';
        pragmaMeta.content = 'no-cache';

        // Add meta elements to the document head
        document.head.appendChild(cacheControlMeta);
        document.head.appendChild(expiresMeta);
        document.head.appendChild(pragmaMeta);

        // Cleanup: remove meta elements when the component unmounts
        return () => {
            document.head.removeChild(cacheControlMeta);
            document.head.removeChild(expiresMeta);
            document.head.removeChild(pragmaMeta);
        };
    }, []);

    const linksDummy = [
        { id: 1, title: "Sitio web", to: 'https://site.alapar.com.gt/', icon: styles['svg-internet'], color: styles.primary },
        //{ id: 2, title: "Instagram", to: 'https://www.instagram.com/coopap.gt/', icon: styles['svg-instagram'], color: styles.primary },
        { id: 3, title: "Nuestra ubicación", to: 'https://www.google.com/maps/place/Via+5+1-36,+Ciudad+de+Guatemala/@14.6215577,-90.5135628,17z/data=!3m1!4b1!4m6!3m5!1s0x8589a230f2de1c27:0xd4f930bbc0a99f94!8m2!3d14.6215577!4d-90.5135628!16s%2Fg%2F1ydpt5yls?entry=tts&g_ep=EgoyMDI0MDkxMC4wKgBIAVAD', icon: styles['svg-location'], color: styles.primary },
        { id: 4, title: "WhatsApp", to: `https://api.whatsapp.com/send/?phone=50230802510&text=${getHref()}`, icon: "fab fa-whatsapp", color: styles.primary },
        { id: 5, title: "Teléfono", to: 'tel:+50223335504', icon: styles['svg-phone'], color: styles.primary },
        { id: 6, title: "Linkedin", to: 'https://www.linkedin.com/company/alapar/?viewAsMember=true', icon: styles['svg-linkedin'], color: styles.primary },
        //{ id: 7, title: "Asesor-IA", to: 'https://wa.me/17373177061?text=Hola, me gustaría su asesoría con mis dudas financieras', icon: styles['svg-user'], color: styles.primary },
    ];

    return (
        <Card className="card text-center p-4" style={{ width: "22rem", backgroundColor: "#c9d1cf", borderRadius: "15px" }}>
            {/* Logo */}
            <Row className="mb-4 d-flex justify-content-center align-items-center">
                <img
                    src={logo} // Replace with your logo path
                    alt="Cooperativa Logo"
                    className="rounded-circle"
                    style={{ width: "150px", height: "auto" }}
                />
            </Row>
            {/* Title and Subtitle */}
            <Card.Title className={styles.title}>Préstamos Hipotecarios</Card.Title>
            <Card.Subtitle className={"mb-3 " + styles.subtitle}>Siempre ALAPAR de ti</Card.Subtitle>
            {/* WhatsApp Icon */}
            {/* Buttons */}
            <Row className="d-grid gap-2">
                {linksDummy.map(link => (
                    <a key={link.id} href={link.to} target="_blank" className={styles['no-style-link'] + styles.button + " btn btn-primary "} style={{ background: link.color }}>
                        {
                            link.icon ?
                                <div className="placeholder-wave m-0 p-0">
                                    <div className={"d-flex justify-content-center align-items-center " + (loading ? 'placeholder placeholder-sm' : '')}>
                                        <i className={link.icon + " " + styles.icon + " " + styles.svg}></i>
                                        <div className={styles['button-text']}>
                                            {link.title}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>{link.title}</div>
                        }
                    </a>
                ))}
            </Row>
        </Card>
    );
}

export default Links;